<app-header/>
<router-outlet />
<app-footer/>